import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="search-field"
export default class extends Controller {
  static targets = ["input", "submitter"]

  connect() {
  }

  inputTargetConnected(element) {
    element.addEventListener("keydown", (e) => {
      if(e.keyCode === 13) {
         e.preventDefault(); this.submitForm(); }
    })
  }

  submitterTargetConnected(element) {
    element.addEventListener("click", this.submitForm.bind(this))
  }

  submitForm() {
    if (!this.hasInputTarget) return
    const form = this.inputTarget.form
    if (form) form.requestSubmit()
  }
}